import React from 'react';
import styled from '@emotion/styled';
import Img from 'gatsby-image';


const GreetSection = styled.section`
    width:80%;
    max-width:100%;

    @media (max-width:${props => props.theme.breakpoints.md}) {
        width:100%;
        height:100%;
    }
    @media (min-width:${props => props.theme.breakpoints.sm}) { 
        vertical-align: bottom;
        display:inline-block;
    }
`;

const Greeting = ({img}) => (
    <GreetSection>
    <Img fluid={img} alt="ご挨拶"/>
</GreetSection>
)

export default Greeting;
